<template>
    <div class="frame">
        <!--头部-->
        <careBotHeader ref="CareBotHeader" />
        <div class="frame-main">
            <router-view :key="keys()" />
        </div>
    </div>
</template>

<script>
import careBotHeader from '@/components/carebot/header';

export default {
    name: 'LayoutIndex',
    components: {
        careBotHeader,
    },
    methods: {
        keys() {
            return Date.now();
        },
    },
};
</script>

<style lang="scss" scoped>
.frame {
    .frame-main {
        position: absolute;
        top: 64px;
        right: 0;
        left: 0;
        bottom: 0;
        overflow: auto;
        width: 640px;
        margin: 0 auto;
    }
}
</style>



// WEBPACK FOOTER //
// src/layout/index.vue